import { Box, Divider, ListItemButton } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { ReactNode } from 'react';

type ListFieldProps = {
    name: string;
    items: Array<{ index: string; icon?: ReactNode; label: ReactNode; subtitle?: string; endIcon?: ReactNode }>;
    hideDivider?: boolean;
    styling?: boolean;
    onClick?: (index: string) => void;
};

export default function ListField(props: ListFieldProps) {
    return (
        <List>
            {props.items.map((item, index) => (
                <Box key={index}>
                    {props.onClick ? (
                        <ListItemButton onClick={() => props.onClick && props.onClick(item.index)}>
                            <ListItem key={item.index} sx={props.styling ? { paddingLeft: '0' } : undefined}>
                                {item.icon && (
                                    <ListItemIcon sx={props.styling ? { minWidth: '40px' } : undefined}>
                                        {item.icon}
                                    </ListItemIcon>
                                )}
                                <ListItemText primary={item.label} secondary={item.subtitle} />
                                {item.endIcon && <ListItemIcon>{item.endIcon}</ListItemIcon>}
                            </ListItem>
                        </ListItemButton>
                    ) : (
                        <ListItem key={item.index} sx={props.styling ? { paddingLeft: '0' } : undefined}>
                            {item.icon && (
                                <ListItemIcon sx={props.styling ? { minWidth: '40px' } : undefined}>
                                    {item.icon}
                                </ListItemIcon>
                            )}
                            <ListItemText primary={item.label} secondary={item.subtitle} />
                            {item.endIcon && <ListItemIcon>{item.endIcon}</ListItemIcon>}
                        </ListItem>
                    )}
                    {!props.hideDivider ? <Divider variant="middle" component="li" /> : null}
                </Box>
            ))}
        </List>
    );
}
